module.exports = __webpack_public_path__ + "img/mainSlide-1.4647e62d.jpg";